import { render, staticRenderFns } from "./ViewPatientEventAdd.vue?vue&type=template&id=8b18c9dc&"
import script from "./ViewPatientEventAdd.vue?vue&type=script&lang=js&"
export * from "./ViewPatientEventAdd.vue?vue&type=script&lang=js&"
import style0 from "./ViewPatientEventAdd.vue?vue&type=style&index=0&id=8b18c9dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports